import React from 'react';
import { useDispatch } from 'react-redux';
import { setModalOpen } from 'store/ResponseTemplate/actions';
import { Button, Typography, Box, Grid } from '@mui/material';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';

function AddAnnouncementFailed() {
    const dispatch = useDispatch();
    const handleClose = () => dispatch({ type: setModalOpen, modalOpen: false });

    return (
        <>
            <Box className="modal-hero">
                <img src={AnnouncementImage} alt="announcement" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    Oops, let’s try again!
                </Typography>
                <Typography variant="p" component="p">
                    Please try again to post this template, make sure that your internet connection is active and stable then press Try
                    Again.
                </Typography>
            </Box>

            <Box className="modal-footer pt-0">
                <Grid container rowSpacing={2}>
                    <Grid item xs={12}>
                        <Button variant="outlined" className="alternate w-full" onClick={handleClose}>
                            Try again
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" className="alternate-reversed w-full" onClick={() => handleClose()}>
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}
export default AddAnnouncementFailed;
